export default class ConstraintValue {
  id;
  nonce;

  type;

  constructor() {
    this.nonce = Math.random().toString(36).substring(7);
  }
}
